import { Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useContext, useEffect, useState } from "react"
import { CondominiosContext } from "../../../../Providers/CondominiosContext/CondominiosContext"
import ComboBox from "../../../../Components/ComboBox/ComboBox"
import OneDatePicker from "../../../../Components/OneDatePicker/OneDatePicker"
import moment from "moment"
import { WebSocketContext } from "../../../../Providers/WebSocket/WebSocketContext"
import { boxInputs, filtrosTypography } from "./sxPeocuraEntregas"
import { showNotify } from "../../../../Utils/Utils"
import { ListaImovelDestinatario } from "../ListaEntregas/EntregaMultipla/EntregaMultipla"
import OneButton from "../../../../Components/OneButton/OneButton"
import { Search } from "@mui/icons-material"
import { EncomendaContex } from "../../../../Providers/EncomendaContext/EncomendaContext"
import OneInput from "../../../../Components/OneInput/OneInput"

const ProcuraEntregas = ({ ativoNavBar }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { activeCond } = useContext(CondominiosContext)
    const { procurarEncomenda, salvarUltimaPesquisa } = useContext(EncomendaContex)
    const [imoveis, setImoveis] = useState([])
    const [imoveisSelecionado, setImoveisSelecionado] = useState([])
    const [resetMorador, setResetMorador] = useState(false)
    const [resetImovel, setResetImovel] = useState(false)
    const [resetKey, setResetKey] = useState(0)

    const listaStatus = [
        { id: 0, descricao: 'Todos' },
        { id: 1, descricao: 'A Retirar' },
        { id: 2, descricao: 'Entregue' }
    ]

    const [formData, setFormData] = useState({
        data_inicial: moment().subtract(15, 'days').format('yyyy-MM-DD HH:mm'),
        data_final: moment().add(15, 'days').format('yyyy-MM-DD HH:mm'),
        status: listaStatus[1].id,
        id_central: activeCond.id_central
    })

    useEffect(() => {
        let pesquisa = { ...formData }
        if (formData?.status == 1) {
            pesquisa.status = 0
        } else if (formData?.status == 2) {
            pesquisa.status = 1
        } else {
            delete pesquisa.status
        }
        salvarUltimaPesquisa(pesquisa)
    }, [formData])

    const getImovel = (msg) => {
        let imoveis = msg.data.imoveis.dados

        if (msg.data.status && Array.isArray(imoveis)) {
            let novoImovel = []
            imoveis.map((imovel) => {
                let objeto = {
                    id: imovel.id,
                    descricao: imovel.unidade1 + ' - ' + imovel.unidade2
                }
                novoImovel.push(objeto)
            })
            setImoveis(novoImovel)
        } else {
            showNotify('warning', 'nenhum imóvel encontrado neste condominio')
        }
    }

    useEffect(() => {
        if (activeCond && activeCond.id_central) {
            sendWs("getImovel", { id_central: activeCond.id_central })
            addRoute("getImovel", getImovel)
            setImoveisSelecionado([])
        }

        if (ativoNavBar) {
            let pesquisa = {
                id_central: activeCond.id_central,
                status: 0,
                data_inicial: moment().subtract(15, 'days').format('yyyy-MM-DD HH:mm'),
                data_final: moment().add(15, 'days').format('yyyy-MM-DD HH:mm')
            }

            procurarEncomenda(pesquisa)
        }
    }, [])

    const handleChangeImoveis = (e) => {
        if (e.target.name === 'imovel') {
            let newImoveis = e.target.value

            if (newImoveis !== formData?.id_imovel) {
                if (newImoveis === 0 || newImoveis === '') {
                    setImoveisSelecionado([])
                    setFormData({ ...formData, id_imovel: newImoveis, cd_acesso: '' })
                    setResetMorador(true)
                } else {
                    setImoveisSelecionado([{ id_imovel: newImoveis }])
                    setFormData({ ...formData, id_imovel: newImoveis, cd_acesso: '' })
                    setResetMorador(true)
                }
            }
        }
    }
    const handleChangeMoradores = (e) => {
        let value = e.target.cd_acesso
        if (value !== undefined) {
            setFormData({ ...formData, cd_acesso: value })
        }
        if (e.target.type == 'morador') {
            setFormData({ ...formData, cd_acesso: '' })
            setResetMorador(true)
        }
    }

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const handleSubmit = () => {
        let pesquisa = { ...formData, id_central: activeCond.id_central }

        if (formData?.morador == '') {
            delete pesquisa.morador
        }

        if (formData?.status == 1) {
            pesquisa.status = 0
        } else if (formData?.status == 2) {
            pesquisa.status = 1
        } else {
            delete pesquisa.status
        }

        if (formData?.data_final == "" || formData?.data_inicial == "") {
            showNotify("warning", "Data é Obrigatorio!")
            return
        }

        if (formData?.tipo == 0) {
            delete pesquisa.tipo
        }

        procurarEncomenda(pesquisa)
        salvarUltimaPesquisa(pesquisa)
    }

    const handleClearFilters = () => {
        const defaultFormData = {
            data_inicial: moment().subtract(15, 'days').format('yyyy-MM-DD HH:mm'),
            data_final: moment().add(15, 'days').format('yyyy-MM-DD HH:mm'),
            status: listaStatus[0].id,
            id_imovel: 0,
            tipo: '0',
            id: '',
            cd_acesso: '',
            morador: ''
        }

        setFormData(defaultFormData)
        setImoveisSelecionado([])
        setResetMorador(true)
        setResetImovel(true)
        setResetKey(prev => prev + 1)

        procurarEncomenda({
            id_central: activeCond.id_central,
            data_inicial: defaultFormData.data_inicial,
            data_final: defaultFormData.data_final
        })
    }

    const listaTipos = [
        { id: 0, descricao: 'Todos' },
        { id: 1, descricao: 'Pacote' },
        { id: 2, descricao: 'Caixa' },
        { id: 3, descricao: 'Envelope' },
        { id: 4, descricao: 'Documento' },
        { id: 5, descricao: 'Outros' }
    ]

    return (
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>

            <Grid xs={12} sm={12} md={12} lg={12} xl={12} spacing={0.5} container key={resetKey}>
                <Grid xs={7.5} sm={7.5} md={7.5} lg={7} xl={7.5}>
                    <ListaImovelDestinatario
                        key={`imovel-${resetKey}`}
                        imoveis={imoveis}
                        activeCond={activeCond}
                        handleChangeImoveis={handleChangeImoveis}
                        handleChangeMoradores={handleChangeMoradores}
                        resetImovel={resetImovel}
                        resetMorador={resetMorador}
                        imoveisSelecionado={imoveisSelecionado}
                        newSx={ '100%' }
                    />
                </Grid>
                <Grid xs={2} sm={2.5} md={2.3} lg={2} xl={2} sx={boxInputs}>
                    <Grid xs={12} sm={6.5} md={6} lg={5} xl={4}>
                        <Typography sx={ filtrosTypography }>Status:</Typography>

                    </Grid>
                    <Grid xs={12} sm={4.5} md={3} lg={6} xl={6}>
                        <ComboBox
                            key={`status-${resetKey}`}
                            defaultValue={formData?.status}
                            name="status"
                            options={listaStatus}
                            todos={true}
                            onChange={handleChange}
                            newSx={{ width: { lg: '65px', xl: '120px', md: '45px', sm: '45px' } }}
                        />
                    </Grid>

                </Grid>
                <Grid xs={12} sm={2} md={2.2} lg={3} xl={2.5} sx={{ display: 'flex', alignItems: 'center' }}>

                    <Grid xs={12} sm={8.5} md={7} lg={4} xl={3}>
                        <Typography sx={ filtrosTypography }>Código:</Typography>
                    </Grid>

                    <Grid xs={12} sm={3.5} md={6} lg={8} xl={9}>
                        <OneInput
                            key={`id-${resetKey}`}
                            onChange={handleChange}
                            name='codigo_rastreio'
                            defaultValue=""
                        />
                    </Grid>

                </Grid>
            </Grid>

            <Grid xs={12} sm={12} md={12} lg={12} xl={12} spacing={1} container>
                <Grid xs={3} sm={2.7} md={3} lg={3.5} xl={3.7} sx={boxInputs}>

                    <Grid xs={12} sm={7} md={6} lg={3.8} xl={4}>
                        <Typography sx={{ ...filtrosTypography, marginLeft: '5px' }}>Dt Ini: </Typography>
                    </Grid>

                    <Grid xs={9.3} sm={5} md={7} lg={8} xl={8}>
                        <OneDatePicker
                            key={`data-inicial-${resetKey}`}
                            name="data_inicial"
                            defaultValue={formData?.data_inicial}
                            callback={handleChange}
                        />
                    </Grid>

                </Grid>

                <Grid xs={3} sm={2.7} md={3} lg={3.5} xl={3.8} sx={boxInputs}>

                    <Grid xs={3} sm={7} md={6} lg={3.8} xl={4}>
                        <Typography sx={filtrosTypography}>Dt Fim: </Typography>
                    </Grid>

                    <Grid xs={3} sm={5} md={7} lg={8} xl={8}>
                        <OneDatePicker
                            key={`data-final-${resetKey}`}
                            name="data_final"
                            defaultValue={formData?.data_final}
                            callback={handleChange}
                        />
                    </Grid>

                </Grid>

                <Grid xs={3} sm={2.6} md={3} lg={3} xl={3} sx={ boxInputs }>

                    <Grid xs={2} sm={6} md={4} lg={3} xl={2} >

                        <Typography sx={ filtrosTypography }>Tipo:</Typography>
                    </Grid>

                    <Grid xs={10} sm={6} md={8} lg={9} xl={10} >
                        <ComboBox
                            key={`tipo-${resetKey}`}
                            defaultValue={'0'}
                            name="tipo"
                            options={listaTipos}
                            todos={true}
                            onChange={handleChange}
                            newSx={{ width: { lg: '110px', xl: '200px', md: '70px', sm: '50px' } }}
                        />
                    </Grid>

                </Grid>

                <Grid xs={3} sm={4} md={3} lg={2} xl={1.5} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1 }}>
                    <OneButton
                        color="one_primary"
                        backgroundColor='true'
                        variant="contained"
                        onClick={handleClearFilters}
                        newSx={{
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden'
                        }}
                    >
                        Limpar
                    </OneButton>
                    <OneButton
                        color="one_primary"
                        backgroundColor='true'
                        variant="contained"
                        onClick={handleSubmit}
                        IconStart={Search}
                        newSx={{
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden'
                        }}
                    >
                        Filtrar
                    </OneButton>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ProcuraEntregas
